var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
 * A simple function to determine if the text is present and not blank.
 */
function textPresent(text) {
    return text && text.trim();
}
/**
 * A component to display a location and address. If any items are missing
 * they will simply not appear in the component.
 */
var Location = /** @class */ (function (_super) {
    __extends(Location, _super);
    function Location() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Location.prototype.render = function () {
        var _a = this.props, location = _a.location, address = _a.address;
        var cityPadding = address && (textPresent(address.stateCode) || textPresent(address.postalCode)) ? ', ' : '';
        var stateCodePadding = address && textPresent(address.postalCode) ? ' ' : '';
        return React.createElement("div", __assign({}, resolveTestId(this.props), resolve(this.props, 'container')),
            React.createElement("div", __assign({}, resolve(this.props, 'name')), location),
            React.createElement("div", __assign({}, resolve(this.props, 'address')), address && React.createElement("div", null,
                React.createElement("div", null, address.address1),
                React.createElement("div", null, address.address2),
                React.createElement("div", null, address.address3),
                React.createElement("div", null,
                    textPresent(address.city) && // TODO: Determine if this span can be removed
                        React.createElement("span", null, address.city + cityPadding),
                    textPresent(address.stateCode) && // TODO: Determine if this span can be removed
                        React.createElement("span", null, address.stateCode + stateCodePadding),
                    React.createElement("span", null, address.postalCode)),
                React.createElement("div", null, address.countryName ? address.countryName : address.countryCode))));
    };
    Location.displayName = 'Location';
    Location.propTypes = {
        location: PropTypes.string,
        address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            address3: PropTypes.string,
            city: PropTypes.string,
            stateCode: PropTypes.string,
            postalCode: PropTypes.string,
            // countryCode will only be used if countryName doesn't exist.
            countryCode: PropTypes.string,
            countryName: PropTypes.string
        })
    };
    return Location;
}(React.Component));
export default Location;
